import { useFirestore, useFirestoreOrderBy, useFirestoreGeneral } from '../../firebase/useFirestore.js';
import { useState, useContext } from 'react';
import KeyboardDoubleArrowRightOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowRightOutlined';
import useSettings from "../../hooks/Settings.jsx";
import { useHistory } from "react-router-dom";
import spinner from '../../images/spinner-ripple.svg'
import firebase from "../../firebase/compat";
import { client } from "../../hooks/Client.js";
import { v4 as uuid } from 'uuid';
import { db } from '../../firebase/config.js';
import { timestamp } from '../../firebase/config.js';
import Face4OutlinedIcon from "@mui/icons-material/Face4Outlined";
import { DeccaContext } from "../../StateManagment/DeccaContext.js";
import newConversation from "../../agents/newConversation.js";
import { Auth } from '../../StateManagment/Auth.js';
import Location from "../../hooks/Location.js";
import usePersonaTerms from "../../hooks/usePersonaTerms.js";

const PersonaAnalysis = () => {
    // Context
    const [auth] = useContext(Auth)
    const {
        chatOpen,
        setChatOpen,
        setSelectedConversationID,
        setShowConversations,
        setSubject,
        setContextData
        } = useContext(DeccaContext);

    // State
    const [selectedPersona, setSelectedPersona] = useState('');
    const [analysis, setAnalysis] = useState([]);
    const [prompt, setPrompt] = useState('');
    const [costs, setCosts] = useState(0);

     // Hooks
     const history = useHistory();
     const pageName = Location()[2];
     const personaTerms = usePersonaTerms();

    // Firestore
    const personas = useFirestoreGeneral('Personas', 'Status', 'active');
    const analysisData = useFirestore('Analysis');
    const conversations = useFirestoreOrderBy('Conversations', 'Position', 'desc');
    const selectedPersonaData = personas && personas.find(persona => persona.ID === selectedPersona);

    // Function to handle analysis with Decca
    const analysisHandler = async () => {
        const conversationID = uuid();
        const title = `Gesprek over ${selectedPersonaData.Name}`;
        const message = `<h2>Hallo ${auth.ForName}</h2><p>Zal ik een algemene analyse doen voor ${selectedPersonaData.Name} of wil je iets specifiekers weten?</p>`
        setSubject('PersonaAnalysis');
        setContextData({
            personaId: selectedPersona,
        })
        setChatOpen(chatOpen === false ? true : true);
        await newConversation(
            conversationID, 
            title, 
            message,
            conversations.length + 1,
            client,
            timestamp,
            uuid(),
            auth.ID,
            auth.ForName,
            db
        );
        setSelectedConversationID(conversationID);
        setShowConversations(false);
    }


    // Function to save the analysis
     const saveAnalysis = (e) => {
     
        db.collection('Analysis')
            .add({
                Content: analysis,
                AverageInput: '', 
                CrossResearchResults: '',
                Type: 'persona-complete-analysis',
                Source: 'software',
                Timestamp: timestamp,
                CompagnyID: client,
                QuestionnaireID: '',
                QuestionFieldID: '',
                ID: uuid(),
                Title: 'Analyse' + (analysisData.length + 1),
                Position: analysisData.length + 1,
            })
            .then(() => {
                history.push(`/${client}/analysis`);
            })
            .catch(error => {
                console.error("Error adding document: ", error);
            });
    };

  return (
    <div className='insights-main-type-container'>
        <div className='insights-main-type-container dashboard-container' >
            <h2>{personaTerms.singular} analyseren</h2>
            <p>Analyseer de voortgang van een {personaTerms.singularLower}</p>
            <p><b>Selecteer {personaTerms.singularLower}</b></p>
            <select name="" id="" onChange={(e) => setSelectedPersona(e.target.options[e.target.selectedIndex].value)}>
                <option value="">Selecteer {personaTerms.singularLower}</option>
                {personas && personas.map((persona) => (
                    <option key={persona.ID} value={persona.ID}>{persona.Name}</option>
                ))}
            </select>
            <div id='page-header-impact-ai-container' className="analysis-ai-container" onClick={analysisHandler}>
                <div id='page-header-impact-ai-inner-container'>
                    <Face4OutlinedIcon/>
                    <p>Analyseer met Decca</p>
                </div>
            </div>
            {/* <div>
                {loading ? <p>Loading...</p> : <p dangerouslySetInnerHTML={{__html: analysis}}></p>}
            </div>
            <div>
                <button
                onClick={saveAnalysis}
                >
                Sla op
                </button>
            </div>*/}
        </div>
    </div>
  )
}

export default PersonaAnalysis
